export enum ReportColumn {
  ORDER_NO = 'order_no',
  EXECUTIVE_NAME = 'executive_name',
  LEAD_NAME = 'lead_name',
  COMPANY_NAME = 'company_name',
  PRODUCTS_NAME = 'products',
  ENQUIRY_CATEGORY = 'enquiry_category',
  ADVANCE_RECEIVED_AMOUNT = 'advance_received_amount',
  ORDER_DATE = 'order_date',
  ORDER_STATUS_DISPLAY = 'order_status_display',
}

// Column display names mapping
export const ReportColumnLabels: Record<ReportColumn, string> = {
  [ReportColumn.ORDER_NO]: 'Order No',
  [ReportColumn.EXECUTIVE_NAME]: 'Executive Name',
  [ReportColumn.LEAD_NAME]: 'Lead Name',
  [ReportColumn.COMPANY_NAME]: 'Company Name',
  [ReportColumn.PRODUCTS_NAME]: 'Products',
  [ReportColumn.ENQUIRY_CATEGORY]: 'Enquiry Category',
  [ReportColumn.ADVANCE_RECEIVED_AMOUNT]: 'Advance Received',
  [ReportColumn.ORDER_DATE]: 'Order Date',
  [ReportColumn.ORDER_STATUS_DISPLAY]: 'Status',
};


// Default selected columns
export const getDefaultSelectedColumns = () => ({
  [ReportColumn.ORDER_NO]: true,
  [ReportColumn.EXECUTIVE_NAME]: true,
  [ReportColumn.LEAD_NAME]: true,
  [ReportColumn.COMPANY_NAME]: true,
  [ReportColumn.PRODUCTS_NAME]: true,
  [ReportColumn.ENQUIRY_CATEGORY]: true,
  [ReportColumn.ADVANCE_RECEIVED_AMOUNT]: true,
  [ReportColumn.ORDER_DATE]: true,
  [ReportColumn.ORDER_STATUS_DISPLAY]: true,
});
export interface SalesReportItem {
  order_no: string;
  executive_name: string;
  lead_name: string;
  company_name: string;
  enquiry_category: string;
  order_date: string;
}

// --------------------------------------------------------------------------------

// src/Pages/Reports/quotationColumns.ts

// Enum for table columns (API response fields)
export enum QuotationTableColumn {
  CREATED_DATE = 'created_date',
  CUI_NO = 'contacts_customer_unique_identification_number',
  EXECUTIVE_NAME = 'executive_name',
  SALES_LEAD_ID = 'sales_lead_id',
  LEAD_NAME = 'lead_name',
  COMPANY_NAME = 'company_name',
  EMAIL= 'email',
  PHONE= 'phone',
  PRODUCT = 'product',
  ENQUIRY_CATEGORY_NAME = 'enquiry_category_name',
  LAST_FOLLOWUP_DATE = 'last_followup_date',
  STATUS = 'status',
}

// Enum for export columns (backend expected fields)
export enum QuotationExportColumn {
  CREATED_DATE = 'created_date',
  CUI_NO = 'contacts_customer_unique_identification_number',
  EXECUTIVE_NAME = 'executive_name',
  SALES_LEAD_ID = 'sales_lead_id',
  LEAD_NAME = 'lead_name',
  COMPANY_NAME = 'company_name',
  EMAIL= 'email',
  PHONE= 'phone',
  PRODUCT = 'product',
  ENQUIRY_CATEGORY_NAME = 'enquiry_category_name',
  LAST_FOLLOWUP_DATE = 'last_followup_date',
  STATUS = 'status',
}

// Column display names mapping (for UI)
export const QuotationColumnLabels: Record<QuotationTableColumn, string> = {
  [QuotationTableColumn.CREATED_DATE]: 'Date',
  [QuotationTableColumn.CUI_NO]: 'CUI No.',
  [QuotationTableColumn.EXECUTIVE_NAME]: 'Executive Name',
  [QuotationTableColumn.SALES_LEAD_ID]: 'Code',
  [QuotationTableColumn.LEAD_NAME]: 'Lead Name',
  [QuotationTableColumn.COMPANY_NAME]: 'Company Name',
  [QuotationTableColumn.EMAIL]: 'Email',
  [QuotationTableColumn.PHONE]: 'Phone',
  [QuotationTableColumn.PRODUCT]: 'Product',
  [QuotationTableColumn.ENQUIRY_CATEGORY_NAME]: 'Enquiry Category',
  [QuotationTableColumn.LAST_FOLLOWUP_DATE]: 'Last Followup Date',
  [QuotationTableColumn.STATUS]: 'Status',
};

// Status filter options for Quotations tab
export const statusFilterOptions = [
  { id: "true", name: "Active" },
  { id: "false", name: "Closed" },
];

// Default selected columns for export (all true)
export const getDefaultQuotationSelectedColumns = () => ({
  [QuotationExportColumn.CREATED_DATE]: true,
  [QuotationExportColumn.CUI_NO]: true,
  [QuotationExportColumn.EXECUTIVE_NAME]: true,
  [QuotationExportColumn.SALES_LEAD_ID]: true,
  [QuotationExportColumn.LEAD_NAME]: true,
  [QuotationExportColumn.COMPANY_NAME]: true,
  [QuotationExportColumn.EMAIL]: true,
  [QuotationExportColumn.PHONE]: true,
  [QuotationExportColumn.PRODUCT]: true,
  [QuotationExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [QuotationExportColumn.LAST_FOLLOWUP_DATE]: true,
  [QuotationExportColumn.STATUS]: true,
});